import { render, staticRenderFns } from "./RealSta.vue?vue&type=template&id=6d31f47b&scoped=true"
import script from "./RealSta.vue?vue&type=script&lang=js"
export * from "./RealSta.vue?vue&type=script&lang=js"
import style0 from "./RealSta.vue?vue&type=style&index=0&id=6d31f47b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31f47b",
  null
  
)

export default component.exports